<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useUser } from '~/stores/user'
const userStore = useUser()
const { userCustomerGroupId } = storeToRefs(userStore)
const userConfigStore = useUserConfig()
const { customerGroupId, priceCategoryId } = storeToRefs(userConfigStore)

const repo = createPricesRepository()

const { locale } = useI18n()

const { data, error } = await useAsyncData(
  'pdf-price-list',
  () =>
    repo.getPdfPriceList({
      customerGroupNid: customerGroupId.value ?? userCustomerGroupId.value ?? 0,
      priceCategoryNid: priceCategoryId.value ?? undefined,
    }),
  {
    watch: [userCustomerGroupId, customerGroupId, priceCategoryId, locale],
  }
)
const { getResourceUrl } = useResources()

function downloadFileFromUrl(): void {
  if (!data.value || !data.value.file) {
    return
  }
  const link = document.createElement('a')
  link.href = getResourceUrl(data.value.file?.url ?? '')
  link.target = '_blank'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
</script>

<template>
  <UiButton
    v-if="data && !error"
    size="sm"
    type="dark"
    class="my-auto flex items-center gap-1"
    @click="downloadFileFromUrl"
  >
    <div class="h-[14px] overflow-hidden">
      <Icon name="ooui:download" class="-mt-[2px]" size="16" />
    </div>
    {{ $t('base.header.PdfPriceList') }}
  </UiButton>
</template>

<style scoped></style>
